export default __webpack_public_path__ + "static/media/CCS-silo-1point5-768x512.5cc61d0f.jpg";